import React from "react";
import { useParams } from "react-router-dom";
import paperPlaneIcon from "../../../assets/images/paper-plane.png";

import * as Icon from "react-feather";

import { H3, P } from "../../atoms/Texts";
import ModalHolder from "../../molecules/ModalHolder";
import { LinkButton, PrimaryButton } from "../../atoms/Buttons";

const CreateReferralFormSuccessModal = ({
  closeModal,
  showShareLinkModal,
  showCodeModal,
}) => {
  const { id } = useParams();

//   const refreshPage = () => {
//     setTimeout(() => {
//         window.location.reload(false);
//     }, 500);
// }

  return (
    <ModalHolder width="50%" closeModal={closeModal}>
      <div className="my-10 mx-12">
        <img src={paperPlaneIcon} alt="" className="h-24 w-24 mx-auto mb-5" />
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          Referral Form Created
        </H3>
        <P className="text-center mt-1" color="#7D7B96">
          Your new program is available for opt-ins.
        </P>
        <div className="flex items-center justify-center gap-6 mt-12">
          <PrimaryButton.Light
            className="flex items-center justify-center py-4"
            onClick={showShareLinkModal}
            style={{ backgroundColor: "#DCD6FE" }}
          >
            <Icon.Share2 size={14} color="#442ED0" />
            <P
              fontSize="14px"
              fontWeight="500"
              className="font-semibold pl-2"
              color="#442ED0"
            >
              Share Link
            </P>
          </PrimaryButton.Light>
          <PrimaryButton.Light
            className="flex justify-center items-center py-4"
            style={{ backgroundColor: "#DCD6FE" }}
            onClick={showCodeModal}
          >
            <Icon.Code size={14} color="#442ED0" />
            <P
              fontSize="14px"
              fontWeight="500"
              className="font-semibold pl-2"
              color="#442ED0"
            >
              Copy Code
            </P>
          </PrimaryButton.Light>
        </div>
        <div className="mt-16 text-center">
          <LinkButton
            style={{ color: "#442ED0" }}
            onClick={() => {window.location=`/dashboard/organization/${id}/referral-forms`}}
            className="font-semibold"
          >
            <P>View all Referral Forms</P>
          </LinkButton>
        </div>
      </div>
    </ModalHolder>
  );
};

export default CreateReferralFormSuccessModal;
